import { motion } from "framer-motion";

const CULTURE_IMG =
  "https://images.unsplash.com/photo-1758518729685-f88df7890776?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjB0ZWFtJTIwbWVldGluZyUyMG9mZmljZXxlbnwwfHx8fDE3Nzg0NzMxODB8MA&ixlib=rb-4.1.0&q=85";

const values = [
  { k: "Inclusive", v: "Diverse minds. Equal voice." },
  { k: "Informal", v: "Flat structures. Real conversations." },
  { k: "Sensitive", v: "Customer at the center of our universe." },
  { k: "Innovative", v: "Out-of-the-box thinking, protocol-driven delivery." },
];

export const Culture = () => {
  return (
    <section data-testid="culture-section" className="bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-6"
          >
            <div className="relative">
              <div
                className="h-80 md:h-[520px] bg-cover bg-center grayscale-[15%]"
                style={{ backgroundImage: `url('${CULTURE_IMG}')` }}
                aria-hidden
              />
              <div className="absolute -bottom-6 -right-6 bg-ink text-white p-6 md:p-8 max-w-xs hidden md:block">
                <div className="overline text-copper mb-3">Our promise</div>
                <p className="font-display text-lg leading-tight">
                  Every single customer is our partner in the pursuit of a common goal.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-6"
          >
            <div className="mb-5">
              <span className="overline text-copper">People & Culture</span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl tracking-tight leading-[1.05] text-ink mb-6">
              Inclusive. Informal.
              <br />
              Sensitive. Innovative.
            </h2>
            <p className="text-base md:text-lg text-slate-600 leading-relaxed mb-10 max-w-xl">
              The sheer joy of working and the innate pride in everything we do
              is at the core of Gradatim culture. We nurture out-of-the-box
              thinking while adhering to standardized protocol and procedures —
              consistently exceeding customer expectations across complex, large
              implementations.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-hairline border border-hairline">
              {values.map((val, i) => (
                <div key={val.k} className="bg-white p-6" data-testid={`value-${i}`}>
                  <div className="font-display text-xl text-ink">{val.k}.</div>
                  <p className="text-sm text-slate-500 mt-1 leading-relaxed">{val.v}</p>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
